import React, { useState } from "react";
import { Fab, Box, Tooltip, Zoom } from "@mui/material";
import { 
  QuestionAnswer as QuestionIcon,
  Calculate as CalculatorIcon
} from "@mui/icons-material";
import SmartFaqChatBot from "./SmartFaqChatBot";
import EnhancedEnquiryModal from "./EnhancedEnquiryModal";

export default function FloatingIcon() {
  const [chatOpen, setChatOpen] = useState(false);
  const [enquiryOpen, setEnquiryOpen] = useState(false);

  const handleChatClose = () => {
    setChatOpen(false);
  };

  const handleEnquiryClose = () => {
    setEnquiryOpen(false);
  };

  return (
    <>
      <Box>
        {/* Chat Button */}
        <Tooltip title="HMIS AI Assistant" placement="left">
          <Zoom in={true}>
            <Fab
              color="primary"
              aria-label="chat"
              onClick={() => setChatOpen(true)}
              sx={{
                position: "fixed",
                bottom: 20,
                right: 20,
                zIndex: 1000
              }}
            >
              <QuestionIcon />
            </Fab>
          </Zoom>
        </Tooltip>

        {/* Calculator Icon for Cost Estimation */}
        <Tooltip title="Cost Estimator" placement="left">
          <Zoom in={true}>
            <Fab
              color="secondary"
              aria-label="calculator"
              onClick={() => setEnquiryOpen(true)}
              sx={{
                position: "fixed",
                bottom: 90,
                right: 20,
                zIndex: 1000
              }}
            >
              <CalculatorIcon />
            </Fab>
          </Zoom>
        </Tooltip>
      </Box>

      <SmartFaqChatBot open={chatOpen} onClose={handleChatClose} />
      <EnhancedEnquiryModal open={enquiryOpen} onClose={handleEnquiryClose} />
    </>
  );
}
